export function getFeedbackRetrievalTimeEstimate(totalRecords?: number) {
  if (!totalRecords) {
    return '';
  }

  if (totalRecords > Math.pow(10, 5)) {
    // if records >100k
    return '45 minutes - 1 Hour';
  }

  const lowerBound = Math.ceil(totalRecords / 10000);
  return `${lowerBound} - ${lowerBound + 5} minutes`;
}
